/* ==== RS1 (2026-09-28): THE ROOM'S STATE, ONE BLOB ====================
   Tommy: "if you open the curtains and then reload the page the curtains
   go back to being shut, right? i'd quite like to persist the curtains
   being open. in fact, i'd quite like to persist the room state in
   general, presumably in local storage", and "shouldn't we extract the
   room state to a single blob to make it easy to persist, restore, etc.?"

   So there is one object and one localStorage key, `tl-room` (JSON), and
   every module that owns a piece of the room reads its piece from here at
   its own init and writes it back the moment it changes. It is loaded
   before every other room module, so a module fetched late (place.js, the
   furniture, voyage.js) finds it already read.

     RoomState.get(key, fallback)   a dotted key reads into a section
                                    ('voyage.charted'); fallback when absent
     RoomState.set(key, value)      updates the object and writes the key;
                                    null / undefined removes the entry
     RoomState.on(key, fn)          fn(value, key) after every set of key
     RoomState.clear()              the whole blob gone, object and key
     RoomState.adopt(key, oldKey, parse)
                                    the one-time move of a pre-RS1 key:
                                    blob empty there -> parse(old raw) goes
                                    in; the old key is removed either way

   What is in it is the ROOM, what a reader left it as: the curtains, the
   forced lamps and fire, the alcove's order, the pit once aligned, the
   voyage's chart. What is NOT: where the reader is (camera, fold, lid,
   head, book page, file card — room deep links were deleted on purpose,
   DL1), the signed run the board scores (tl-survey-progress and its
   siblings, progress.js), and the sky's cache.

   `?charted=<digits>` (the harness's lever that already set the voyage
   from nothing) clears the blob on load, and `fresh` says so, so `adopt`
   does not pull a stale pre-RS1 key back in behind it.

   localStorage throws outright in a third-party frame and in some private
   windows, so every touch is guarded and the object in memory is the
   truth for the page either way. ======================================= */
(function (root) {
'use strict';

var KEY = 'tl-room';
var data = {}, subs = {};
var fresh = /^\d+$/.test(new URLSearchParams(location.search).get('charted') || '');

function store() {
  try {
    var s = JSON.stringify(data);
    if (s === '{}') root.localStorage.removeItem(KEY);
    else root.localStorage.setItem(KEY, s);
  } catch (e) { /* this page only */ }
}
function load() {
  try {
    var o = JSON.parse(root.localStorage.getItem(KEY) || '{}');
    if (o && typeof o === 'object' && !Array.isArray(o)) data = o;
  } catch (e) { data = {}; }
}
if (fresh) { try { root.localStorage.removeItem(KEY); } catch (e) { } }
else load();

function walk(key, make) {
  var path = String(key).split('.'), o = data, i;
  for (i = 0; i < path.length - 1; i++) {
    if (!o[path[i]] || typeof o[path[i]] !== 'object') {
      if (!make) return null;
      o[path[i]] = {};
    }
    o = o[path[i]];
  }
  return { o: o, k: path[path.length - 1] };
}

var RS = {
  fresh: fresh,
  get: function (key, fallback) {
    var w = walk(key, false);
    return (w && w.o[w.k] !== undefined) ? w.o[w.k] : fallback;
  },
  set: function (key, value) {
    var w = walk(key, true);
    if (value === null || value === undefined) delete w.o[w.k];
    else w.o[w.k] = value;
    store();
    (subs[key] || []).forEach(function (fn) { try { fn(value, key); } catch (e) { } });
    return value;
  },
  on: function (key, fn) {
    if (typeof fn === 'function') (subs[key] = subs[key] || []).push(fn);
  },
  clear: function () {
    data = {};
    try { root.localStorage.removeItem(KEY); } catch (e) { }
  },
  adopt: function (key, oldKey, parse) {
    var raw = null;
    try { raw = root.localStorage.getItem(oldKey); } catch (e) { }
    if (raw !== null) {
      if (!fresh && RS.get(key) === undefined) RS.set(key, parse ? parse(raw) : raw);
      try { root.localStorage.removeItem(oldKey); } catch (e) { }
    }
    return RS.get(key);
  },
  /* the whole blob, a copy, for reading */
  all: function () { return JSON.parse(JSON.stringify(data)); }
};
root.RoomState = RS;
})(window);
